// extracted by mini-css-extract-plugin
export default {"list":"CustomList_list__yk89I"};